module.exports = __webpack_public_path__ + "assets/img/text-to-speech-app2.817daefd.png";